import { Container, Title, Text, Button, SimpleGrid, Box } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import { useStyles } from './styles';
import { ErrorPageBackgroundImage } from '@assets/icons';
import { useTranslation } from 'react-i18next';

export function NotFound() {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const navigate = useNavigate();

  const goMainPage = () => {
    navigate('/');
  };

  return (
    <Container className={classes.root}>
      <SimpleGrid cols={{ base: 1, sm: 2 }} spacing={{ base: 40, sm: 80 }}>
        <Box className={classes.mobileImage}>
          <ErrorPageBackgroundImage />
        </Box>

        <div>
          <Title className={classes.title}>{t('notFound.error')}</Title>
          <Text className={classes.description} color="dimmed">
            {t('notFound.description')}
          </Text>
          <Button
            variant="outline"
            size="md"
            mt="xl"
            className={classes.control}
            onClick={goMainPage}
          >
            {t('notFound.back')}
          </Button>
        </div>

        <Box className={classes.desktopImage}>
          <ErrorPageBackgroundImage />
        </Box>
      </SimpleGrid>
    </Container>
  );
}
